import axios from "services/axios";
import {useMutation, useQueryClient} from "react-query";

import {QUERY} from "./useQueryMedicineCategory";

export function useAddMedicineCategory() {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.post("/medicine/category/add", formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY);
			queryClient.removeQueries(QUERY);
			queryClient.invalidateQueries("medicineCategoryOptionsHospital");
			queryClient.removeQueries("medicineCategoryOptionsHospital");
		},
	});
}

export function useChangeDataStatus() {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.post("/medicine/category/change_status", formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY);
			queryClient.removeQueries(QUERY);
			queryClient.invalidateQueries("medicineCategoryOptionsHospital");
			queryClient.removeQueries("medicineCategoryOptionsHospital");
		},
	});
}
